import axios from '../config/axios';

function isAuthError(err) {
  const status = err?.response?.status;
  return status === 401 || status === 403;
}

export const fetchAttachmentsById = async (id, token) => {
  try {
    const res = await axios.get(`/attachments/entries/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return res.data;
  } catch (err) {
    if (isAuthError(err)) {
      // Global axios interceptor will handle logout; don't show redbox/toast.
      return;
    }
    console.error(`Error fetching attachments for entry ${id}:`, err);
    throw err;
  }
};
